export default __webpack_public_path__ + "static/media/blockIcon.9158dd3c.svg";